import React from "react";
import {useNavigate} from "react-router-dom";
import {getPurchaseListByAsset} from "../../../../api/asset/PurchaseService";
import {PURCHASE_LIST_HEADER} from "../../../../components/table/header/Headers";
import useRequestData from "../../../../hooks/useRequestData";
import DetailLinkedListView from "../../../../components/detailLayout/DetailLinkedListView";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../components/pageTabs/pageTabsStorage";

function AssetPurchase({id}) {
    const navigate = useNavigate();
    const {newData, dataHook} = useRequestData((conditions, pageable) => {
        return getPurchaseListByAsset(id, pageable);
    }, {});

    const handleRowClick = (row) => {
        const rowId = row?.id;
        if (rowId == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "구매 상세"),
            url: `/asset/purchase/${rowId}`,
        });
    };

    return (
        <DetailLinkedListView
            headerDefinition={PURCHASE_LIST_HEADER}
            settingKey="purchase"
            newData={newData}
            onPageChange={dataHook.handleGridPageChange}
            onRowClick={handleRowClick}
        />
    );
}

export default AssetPurchase;
